import { QuantityComponent } from './';

const QuantityComponents = (selector = '[sh-quantity-component]') => {
  const elements = document.querySelectorAll(selector);
  if (typeof elements !== 'undefined' && elements.length > 0) {
    elements.forEach((el) => {
      let quantityComponent = new QuantityComponent(el);
    });
  }
};

export default QuantityComponents;
